export default "/_next/static/images/Modern-010249a606cd8bc411dff61031171712.png";